import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayPendingConfigOPEEnum} from "./GatewayPendingConfigOPEEnum";

// Drops the `gateway` block from the pending-config draft, leaving the devices already
// drafted untouched. Counterpart of revertDevicePendingConfig for the gateway fields.
class O {
  gatewayId!: number;
  updateTs?: string;
}

class I {
  gatewayId!: number;
}

export class RevertGatewayFieldsPendingConfigCB extends BaseSpringServiceCB {
  public i: I;
  public o: O;

  constructor() {
    super(GatewayPendingConfigOPEEnum.RevertGatewayFieldsPendingConfig);
    this.i = new I();
    this.o = new O();
  }
}
